import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import MasterObat from "./pages/MasterObat";
import Locations from "./pages/Locations";
import StockOpname from "./pages/StockOpname";
import Reports from "./pages/Reports";
import Riwayat from "./pages/Riwayat";
import Users from "./pages/Users";
import SaldoMaster from "./pages/SaldoMaster";
import Mutasi from "./pages/Mutasi";
import Temuan from "./pages/Temuan";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        <div className="animate-pulse font-head font-semibold">Memuat...</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="master-obat" element={<AdminRoute><MasterObat /></AdminRoute>} />
              <Route path="tempat-penyimpanan" element={<AdminRoute><Locations /></AdminRoute>} />
              <Route path="stock-opname" element={<StockOpname />} />
              <Route path="saldo-master" element={<SaldoMaster />} />
              <Route path="temuan" element={<Temuan />} />
              <Route path="mutasi" element={<AdminRoute><Mutasi /></AdminRoute>} />
              <Route path="riwayat" element={<Riwayat />} />
              <Route path="laporan" element={<Reports />} />
              <Route path="pengaturan" element={<AdminRoute><Users /></AdminRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
